import React from 'react';
import styled from 'styled-components';
import { NavLink, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faFacebook } from '@fortawesome/free-brands-svg-icons';

import useConfigs from '../hooks/useConfigs';
import useFooterMenus from '../hooks/parameter/useFooterMenus';

export const Footertwo = () => {
  const { fontSizeMultiplier, activeTheme } = useConfigs();

  const {
    footerGenerales,
    footerNormatividad,
    lineaAtencionInfo,
    pqrInfo,
    socialMedia,
  } = useFooterMenus();


  const history = useHistory();

  const logo = {
    DEFAULT: 'img/famedic-logo.png',
    ROSADO: 'img/Famedic-blanco.png',
    DARK: 'img/Famedic-blanco.png',
  };

  const background = {
    DEFAULT: activeTheme?.color_base_secundario,
    ROSADO: activeTheme?.color_base_1,
    DARK: activeTheme?.color_base_1,
  };

  const color = {
    DEFAULT: activeTheme?.color_base_tipografia,
    ROSADO: activeTheme?.color_base_blanco,
    DARK: activeTheme?.color_base_blanco,
  };

  const colorTitle = {
    DEFAULT: activeTheme?.color_base_ppal,
    ROSADO: activeTheme?.color_base_blanco,
    DARK: activeTheme?.color_base_blanco,
  };

  const heinsohnBackground = {
    DEFAULT: activeTheme?.color_base_4,
    ROSADO: activeTheme?.color_base_3,
    DARK: activeTheme?.color_base_3,
  };

  return (
    <>
      <Container
        fontsizemultiplier={fontSizeMultiplier}
        tema={activeTheme}
        background={background[activeTheme?.nombre]}
        color={color[activeTheme?.nombre]}
        colortitle={colorTitle[activeTheme?.nombre]}
      >
        <div className='logo-container'>
          <img src={logo[activeTheme?.nombre]} alt='logo' />
        </div>

        <div className='general-container'>
          <div>
            <p className='title'>Generales</p>
            {footerGenerales.map((item) => (
              <div
                className='option'
                key={item.id}
                onClick={() => {
                  history.push(item.rutaOpcion);
                }}
              >
                {item.nombreOpcion}
              </div>
            ))}
          </div>
          <div>
            <p className='title'>Normatividad</p>
            {footerNormatividad.map((item) => (
              <div
                className='option'
                key={item.id}
                onClick={() => {
                  history.push(item.rutaOpcion);
                }}
              >
                {item.nombreOpcion}
              </div>
            ))}
          </div>
        </div>

        <div className='linea-container'>
        <div>
            {/* <p className='info' style={{cursor: "pointer"}}
              onClick={() => {
                  history.push("/politicadatospersonales");
                }}>
                  Política de tratamiento de datos personales
            </p> */}
            {/* <p className='info' style={{cursor: "pointer"}}
              onClick={() => {
                  history.push("/avisoprivacidad");
                }}>
                  Aviso de privacidad
            </p> */}
            <p className='title'>Voz del Afiliado</p>
            <p className='subtitle'>{pqrInfo?.texto}</p>
            <p className='info'>{pqrInfo?.email}</p>
          </div>
          <div>
            <p className='title'>Línea de atención</p>
            <p className='subtitle'>{lineaAtencionInfo?.texto}</p>
            <p className='info'>{lineaAtencionInfo?.tel}</p>
          </div>
        </div>

        <div className='social-media'>
          {/* <p className='title'>nuestras redes</p> */}
          <p className='title'>Nuestras redes sociales</p>
          <div>
            <a
              className='twitter'
              href={socialMedia?.twitter}
              target='_blank'
              rel='noreferrer'
            >
              <FontAwesomeIcon
                icon={faTwitter}
                color={color[activeTheme?.nombre]}
                size='2x'
              />
            </a>
            <a href={socialMedia?.facebook} target='_blank' rel='noreferrer'>
              <FontAwesomeIcon
                icon={faFacebook}
                color={color[activeTheme?.nombre]}
                size='2x'
              />
            </a>
          </div>
        </div>
      </Container>
      <Heinsohn
        fontsizemultiplier={fontSizeMultiplier}
        tema={activeTheme}
        heinsohnbackground={heinsohnBackground[activeTheme?.nombre]}
      >
        <p>&copy; Copyright 2022 - Todos los derechos reservados</p>
        <p>Desarrollado por:</p>
        <img src='img/LogoHeinsohnBlanco.png' alt='Heinsohn' />
      </Heinsohn>
    </>
  );
};

const Container = styled.div`
  padding: 3rem 2rem;
  background-color: ${(props) => props.background};

  .logo-container {
    margin-bottom: 2rem;

    img {
      width: 20rem;
    }
  }

  .general-container {
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 1rem;

    .option {
      margin-bottom: 1.5rem;
      font-size: ${(props) => 18 * props.fontsizemultiplier};
      color: ${(props) => props.color};
      cursor: pointer;

      &:active {
        filter: brightness(1.2);
      }

      &:hover {
        filter: brightness(1.2);
      }
    }
  }

  .linea-container {
    .subtitle {
      font-size: ${(props) => 18 * props.fontsizemultiplier};
      font-weight: 700;
      line-height: normal;
      color: ${(props) => props.color};
    }
  }

  .title {
    font-size: ${(props) => 18 * props.fontsizemultiplier};
    font-weight: 700;
    text-transform: uppercase;
    color: ${(props) => props.colortitle};
  }

  .info {
    font-size: ${(props) => 18 * props.fontsizemultiplier};
    color: ${(props) => props.color};
    &:hover {
      filter: brightness(1.2);
    }
  }

  .social-media {
    display: flex;
    flex-direction: column;

    .twitter {
      margin-right: 2rem;
      padding-right: 2rem;
      border-right: 1px solid ${(props) => props.color};
    }
  }

  @media (min-width: 1023px) {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(20rem, 1fr));
    padding: 3rem;
  }
`;

const Heinsohn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.heinsohnbackground};
  padding: 2rem 1rem;
  text-align: center;

  p {
    cursor: pointer;
    font-size: 14px;
    color: ${(props) => props.tema?.color_base_blanco};
    &:hover {
      filter: brightness(1.2);
    }
  }

  img {
    width: 12rem;
  }
`;
